module.exports = __webpack_public_path__ + "static/logo-transparent-5e6150a95f442407ef9263e118e5797c.png";